import { useConfirmDialog } from '@vueuse/core';

const dialog = useConfirmDialog();

const useGlobalDialog = <Model>() => dialog as ReturnType<typeof useConfirmDialog<GlobalDialogParams<Model>, Model>>;

export default useGlobalDialog;
